import getDateFromISO from './getDateISO';

const formatFinnishDate = (dateISO: string) => {
  const date = getDateFromISO(dateISO);
  return `${date.getDate()}.${date.getUTCMonth() + 1}.${date.getUTCFullYear()}`;
};

export default formatFinnishDate;
